import { render, staticRenderFns } from "./footNav.vue?vue&type=template&id=51bda87f&"
import script from "./footNav.vue?vue&type=script&lang=js&"
export * from "./footNav.vue?vue&type=script&lang=js&"
import style0 from "./footNav.vue?vue&type=style&index=0&id=51bda87f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports